import React from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { Dropdown } from './Dropdown';

interface SupportDropdownProps {
  location: {
    hash: string;
  };
}

export function SupportDropdown({ location }: SupportDropdownProps) {
  return (
    <Dropdown 
      title="Jak Pomóc"
      isActive={location.hash === '#donation' || location.hash === '#volunteer' || location.hash === '#foster'}
    >
      <div className="py-2 min-w-[280px]">
        
        <Link to="/wsparcie" className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2">
        <Heart className="w-4 h-4 text-accessible-red-600" />
          Jak możesz pomóc
        </Link>
        <div className="border-t border-accessible-gray-200 dark:border-accessible-gray-700 high-contrast:border-white/20 my-2 mx-4"></div>
        <Link to="/wplata-jednorazowa" className="flex items-center gap-3 px-4 py-2 text-sm font-medium text-accessible-red-600 hover:bg-accessible-red-50 dark:hover:bg-accessible-red-600/10 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2">
          WPŁAĆ TERAZ
        </Link>
        <Link to="/wsparcie" className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2">
          Zostań stałym darczyńcą
        </Link>
        <Link to="/przekaz-podatek" className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2">
          Przekaż 1.5% podatku
        </Link>
        <div className="border-t border-accessible-gray-200 dark:border-accessible-gray-700 high-contrast:border-white/20 my-2 mx-4">
        <Link to="/wolontariat" className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2">
          Zostań wolontariuszem
        </Link>
        <Link to="/dom-tymczasowy" className="flex items-center gap-3 px-4 py-2 text-sm text-accessible-gray-700 dark:text-accessible-gray-300 high-contrast:text-white hover:bg-accessible-gray-100 dark:hover:bg-accessible-gray-800 high-contrast:hover:bg-white/10 transition-colors rounded-md mx-2">
          Dom tymczasowy
        </Link>
        </div>
      </div>
    </Dropdown>
  );
}